import {
  addQuestion,
  deleteQuestion,
  getQuestions,
  updateQuestion,
} from "../actions/question.action";
import TableList from "../components/TableList";
import { Question } from "../models/question.model";
import { useRef } from "react";
import QuestionForm from "./QuestionForm";
import { filterOnKeys, titleStr } from "../lib/helper";
import { FilterGroup, FilterType } from "../components/TableFilter";
import { FormRefEvent, HeadCell } from "../models/base.model";

const headCells: readonly HeadCell[] = [
  {
    id: "name",
    label: "Name",
  },
  {
    id: "type",
    label: "Type",
    render: (v) => titleStr(v),
  },
  {
    id: "content",
    label: "Content",
  },
];

const filters: FilterGroup<Question>[] = [
  {
    title: "Filter By Date",
    items: [
      {
        name: "createdAt",
        type: FilterType.date_range,
      },
      {
        name: "updatedAt",
        type: FilterType.date_range,
      },
    ],
  },
  {
    title: "Filter By Question Type",
    items: [
      {
        name: "type",
        type: FilterType.selection,
      },
    ],
  },
];

export default function Questions() {
  const formRef = useRef<FormRefEvent<Question>>(null);

  const onAddOrUpdate = (param?: Question) => {
    return window.webApp.setTab<Question>({
      title: `${param ? "Update" : "New"} Question`,
      element: <QuestionForm ref={formRef} defaultValues={param} />,
      onOk: async () => {
        if (!formRef.current) {
          throw new Error("Form creation error, please refresh or contact us!");
        }
        const value = await formRef.current.onSubmit();
        const res = param
          ? await updateQuestion({ ...param, ...value })
          : await addQuestion(value);
        return res;
      },
      show: true,
    });
  };

  const onDelete = (param: Question) => {
    return deleteQuestion(param.id);
  };

  const onSearch = async (value: string, original: Question[]) => {
    if (original) {
      return {
        data: original.filter((a) =>
          filterOnKeys(a, ["name", "type", "content"], value),
        ),
      };
    } else {
      return { data: [] };
    }
  };

  return (
    <TableList<Question>
      headCells={headCells}
      onAddBtnText="New Question"
      uid="id"
      onAdd={onAddOrUpdate}
      onSearch={onSearch}
      searchText="Search by name, type, content"
      onEdit={onAddOrUpdate}
      onDelete={onDelete}
      onLoad={getQuestions}
      filters={filters}
    />
  );
}
